import normalizeMessageType from '../../../lib/normalizeMessageType.js';
import sortByDateProp from '../../../lib/sortByDateProp.js';

export const formatMessages = (messages = [], opts = {}) => {
  return messages.map((n) => {
    let additional_properties = n.additional_properties;
    if (additional_properties) {
      try {
        additional_properties = JSON.parse(additional_properties);
      } catch (e) {}
    }

    return {
      ...n,
      additional_properties,
      type: normalizeMessageType(n.type),
      unique_id: `${n.id}_${normalizeMessageType(n.type)}`,
      data_source: opts.dataSource,
      creationDatetime: n.creation_datetime,
    };
  });
};

export const formatAllMessages = (messages = []) => {
  let dict = {};
  return messages
    .sort(sortByDateProp('creationDatetime', 'desc'))
    .sort((a, b) => {
      return a.rehydrated && !b.rehydrated ? -1 : b.rehydrated && !a.rehydrated ? 1 : 0;
    })
    .filter((n) => {
      const key = `${n.unique_id}_${n.data_source}`;
      dict[key] = dict[key] || 0;
      dict[key]++;
      return dict[key] < 2;
    });
};

export const formatCommunicationLogsMessages = (messages) => {
  return formatMessages(messages, { dataSource: 'communicationLogs' });
};

export const formatInboxCombinedMessages = (messages, folderId) => {
  return formatMessages(messages, { dataSource: `inbox_${folderId}` });
};

export const formatLeadModalChatMessages = (messages) => {
  return formatMessages(messages, { dataSource: 'leadModalChat' });
};
